import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class OneLogin extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Zm1.78,9.837v6.48a.273.273,0,0,1-.273.273H11.256a.274.274,0,0,1-.273-.273V11.078H9.268a.274.274,0,0,1-.273-.273V8.554a.274.274,0,0,1,.273-.273h4.239a.273.273,0,0,1,.273.273Z" />
      </svg>
    );
  }
}

export default OneLogin;
